export default function Layout({children}) {
    return <div className="content-min-height">{children}</div>
}

export function Main({className = "", children}) {
    return <main className={"container-fluid " + className}>{children}</main>
}

export function FiltersTable({Filters, Table}) {
    return (
        <div className="content d-flex flex-column flex-column-fluid">
            <div className="container-fluid">
                <div className="py-3 py-lg-6">
                    <div className="card">
                        <div className="col-xxl-12">
                            <div className="row g-8 p-8 d-flex flex-row align-items-end">
                                <div className="col">{Filters}</div>
                            </div>
                            <div className="card-body pt-0">
                                <div className="table-responsive">{Table}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
